const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

//const Backofficebff: any = "/api/v1";
export const DataQuery: any = {
    GetBankList: Backofficebff + '/v1/data/getbanklist',
};
